import React from "react";

import AuthUserContext from "./context";
import { withFirebase } from "../Firebase";
import DbFactory from "../../repository/DbFactory";

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
        loading: true,
      };
    }

    componentDidMount() {
      this.listener = this.props.firebase.auth.onAuthStateChanged(
        (authUser) => {
          if (authUser) {
            this.props.firebase
              .user(authUser.uid)
              .once("value")
              .then((snapshot) => {
                const full_user_data = snapshot.val();
                
                // Handle case where user has no data yet (e.g., fresh emulator)
                if (!full_user_data || !full_user_data.organizations) {
                  console.warn('User has no organization data yet');
                  this.setState({ authUser: null, loading: false });
                  return;
                }
                
                const default_organization = Object.keys(
                  full_user_data["organizations"]
                )[0];
                DbFactory.setLastOrganization(default_organization);

                const newUser = {
                  ...authUser,
                  ...full_user_data,
                  default_organization,
                };
                this.setState({ authUser: newUser, loading: false });
              });
          } else {
            this.setState({ authUser: null, loading: false });
          }
        }
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Provider value={{ authUser: this.state.authUser, loading: this.state.loading }}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
